import React, { useEffect, useRef, useState } from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Tr from "../common/table/tr";
import NewTr from "../common/table/newTr";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Td from "../common/table/td";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import Select from "../common/form/select";
import LabelAndCheckbox from "../common/form/labelAndCheckbox";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import LabelAndTextarea from "../common/form/labelAndTextarea";
import LabelAndInputDate from "../common/form/labelAndInputDate";
import RadioButton from "../common/form/radioButton";
import {
    setModoTelaUC,
    initUcForm,
    excluirUC,
    reativarUC,
    alterarPropriedadeUC,
    getListaUCsCliente,
    buscarTiposContratoAtivo,
    salvarUCAgua,
    excluirUCAgua,
} from "./clienteActions";
import LabelAndInputMask from "../common/form/labelAndInputMask";
import imagemLampada from "../assets/images/lampada.png";
import imagemGota from "../assets/images/gota.png";
import AlertIcon from "../common/alertIcon/alertIcon";
import DateFormat from "../common/dateFormat/DateFormat";
import { adicionarPontosMilhar } from "../utils/adicionarPontosMilhar.js";
import UnidadeConsumidoraAguaForm from "./unidadeConsumidoraAguaForm.jsx";
import { BotaoEditarCampoUc } from "./components/BotaoEditarCampoUc.jsx";
import { YesNoModal } from "../common/dialog/YesNoModal.jsx";
import { setWarning } from "../common/toast/toast.jsx";

function UnidadeConsumidoraForm(props) {
    const botaoSubmitRef = useRef();

    const [state, setState] = useState(() => {
        const uc = props.ucFormularioValues;
        const exibirTransformarRemotaEmGeradora = !!uc.competencia_inicio_geracao;
        const exibirUnidadesFilhasMercadoLivre = !!uc.unidades_filhas_mercado_livre.length;
        const idUcFilhaMercadoLivre = null;
        const exibirGeradoraRemota = !uc.competencia_inicio_geracao && uc.geracao && (uc.id_unidade_geradora || uc.geradora_externa);

        const classificacaoGeracao = uc.remota
            ? "Unidade Remota"
            : uc.geracao
              ? exibirTransformarRemotaEmGeradora
                  ? "Remota que virou Geradora"
                  : exibirGeradoraRemota
                    ? "Unidade Geradora/Remota"
                    : "Unidade Geradora (Própria)"
              : null;

        return {
            campoEdicao: null,
            ucOriginal: { ...uc },
            exibirTransformarRemotaEmGeradora,
            exibirUnidadesFilhasMercadoLivre,
            exibirUsuarioSenhaMercadoLivre: exibirUsuarioSenhaMercadoLivre(),
            idUcFilhaMercadoLivre,
            classificacaoGeracao,
            abaEnergiaAtiva: true,
            abaAguaAtiva: false,
            exibirModalSairTela: false,
            exibirModalAlteracaoUcTrocaAba: false,
            exibirModalAlteracaoUcVoltar: false,
            exibirModalConfirmarSubmit: false,
            tituloConfirmarSubmit: null,
            submitPendente: null,
        };
    });

    useEffect(() => {
        if (!props.ucFormularioValues.id_plataforma_mercado_livre) return;

        const exibirUsuarioSenha = exibirUsuarioSenhaMercadoLivre();

        if (!exibirUsuarioSenha) {
            props.initUcForm({
                ...props.ucFormularioValues,
                usuario_mercado_livre: null,
                senha_mercado_livre: null,
            });
        }
        setState({ ...state, exibirUsuarioSenhaMercadoLivre: exibirUsuarioSenha });
    }, [props.ucFormularioValues.id_plataforma_mercado_livre]);

    useEffect(() => {
        if (!props.ucFormularioValues.id || !state.ucOriginal.id) return;

        if (
            state.ucOriginal.id_modalidade_tarifaria != props.ucFormularioValues.id_modalidade_tarifaria &&
            props.ucFormularioValues.id_modalidade_tarifaria == 1 &&
            props.tiposContratosDemandaAtivosUc.contrato_ponta
        ) {
            setWarning(
                'Aviso: Existe um contrato de demanda ponta para esta UC. Alterando a UC para horossazonal verde fará com que a aba "Contrato de Demanda Ponta" fique oculta no cadastro de contrato de demanda.'
            );
        }
    }, [props.ucFormularioValues.id_modalidade_tarifaria, props.tiposContratosDemandaAtivosUc.contrato_ponta, state.ucOriginal.id]);

    useEffect(() => {
        if (!props.ucFormularioValues.id || !state.ucOriginal.id) return;

        if (state.ucOriginal.geracao != props.ucFormularioValues.geracao && !props.ucFormularioValues.geracao && props.tiposContratosDemandaAtivosUc.contrato_geracao) {
            setWarning(
                'Aviso: Existe um contrato de demanda de geração para esta UC. Desmarcar a opção de geração da UC fará com que a aba "Contrato de Demanda Geração" fique oculta no cadastro de contrato de demanda.'
            );
        }
    }, [props.ucFormularioValues.geracao, props.tiposContratosDemandaAtivosUc.contrato_geracao, state.ucOriginal.id]);

    useEffect(() => {
        if (props.ucFormularioValues.id) {
            props.buscarTiposContratoAtivo(props.ucFormularioValues.id);
        }

        window.scrollTo(0, 0);
    }, []);

    function focarBotaoSubmit() {
        if (botaoSubmitRef.current) {
            botaoSubmitRef.current.focus();
        }
    }

    function exibirUsuarioSenhaMercadoLivre() {
        const plataformaSelecionada = props.listaPlataformaMercadoLivre.find((p) => p.id == props.ucFormularioValues.id_plataforma_mercado_livre);
        return !plataformaSelecionada || !plataformaSelecionada.integracao_por_email;
    }

    function getEstiloAba(aba) {
        return {
            padding: "15px 0px 5px 10px",
            backgroundColor: aba ? "#FFF" : "#e6e6e6",
            color: aba ? "#000" : "#bababa",
            marginBottom: -5,
            zIndex: aba ? 1 : 0,
            borderRadius: "10px 10px 0 0",
            boxShadow: "#ddd 1px -7px 8px 1px",
            border: "solid 1px #ddd",
            borderBottom: "none",
            cursor: "pointer",
        };
    }

    if (!props.ucFormularioValues || !state) return null;

    function validarAlteracoesFormulario() {
        if (!state.ucOriginal) return;
        const ucAntes = JSON.parse(JSON.stringify(state.ucOriginal));
        delete ucAntes.unidades_consumidoras_agua;
        const ucDepois = JSON.parse(JSON.stringify(props.ucFormularioValues));
        delete ucDepois.unidades_consumidoras_agua;

        return JSON.stringify(ucAntes) !== JSON.stringify(ucDepois);
    }

    const readOnly = !!(props.excluir || props.editarCampoUC || props.visualizar || props.reativar || props.ucFormularioValues.bloquearEdicaoUcUsuarioImplantacao);

    const usuarioPodeEditarAcessos = !!(props.editarCampoUC && props.usuarioLogado.acesso_credenciais_concessionaria_editar);
    const usuarioPodeEditarCodigoUC = !!(props.editarCampoUC && props.usuarioLogado.acesso_codigo_uc_editar);

    //usado para mostrar em um input somente leitura
    const aliquota_icms = (
        props.listaTributacao.find(
            (tributacao) => tributacao.id_estado == props.ucFormularioValues.id_estado && tributacao.id_atividade == props.ucFormularioValues.id_atividade
        ) || {}
    ).aliquota_icms;

    const listaUCsGeradorasAtivas = (props.listaUcCliente || []) //não lista geradoras que também são remotas, pq se elas ja dependem de outra, devem ter usado 100 da sua própria produção
        .filter((uc) => uc.geracao && (!uc.id_unidade_geradora || uc.competencia_inicio_geracao) && uc.ativo && !uc.data_desligamento && uc.id != props.ucFormularioValues.id)
        .map((uc) => ({
            id: uc.id,
            valor: uc.numero + " - " + uc.nome,
        }));

    const listaUCsMercadoLivre = (props.listaUcCliente || []) //lista todas as ucs ativas, exceto ela mesma
        .filter(
            (uc) =>
                uc.ativo &&
                !uc.data_desligamento &&
                uc.id != props.ucFormularioValues.id &&
                uc.id_tipo_mercado == 2 &&
                !props.ucFormularioValues.unidades_filhas_mercado_livre.find((el) => el.id_unidade_consumidora == uc.id) &&
                !uc.unidade_mae_mercado_livre &&
                !uc.unidade_filha_mercado_livre
        )
        .map((uc) => ({
            id: uc.id,
            valor: uc.numero + " - " + uc.nome,
        }));

    listaUCsGeradorasAtivas.unshift({ id: 0, valor: "Usina Externa - Fonte Não Informada" });

    const exibirBotaoTransformarRemotaGeradora =
        props.ucFormularioValues.id && props.ucFormularioValues.remota && (props.ucFormularioValues.id_unidade_geradora || props.ucFormularioValues.geradora_externa);

    function submitComCallback(values) {
        const callback = () => {
            setState((prev) => ({
                ...prev,
                ucOriginal: { ...props.ucFormularioValues },
                exibirModalSairTela: true,
            }));
        };

        const submitPendente = () => props.onSubmit(values, callback);

        setState((prev) => ({
            ...prev,
            submitPendente,
            exibirModalConfirmarSubmit: true,
            tituloConfirmarSubmit: `Deseja realmente ${props.ucFormularioValues.id ? "salvar as alterações na" : "incluir a"} unidade consumidora?`,
        }));
    }

    return (
        <ContentCard>
            <YesNoModal
                title={state.tituloConfirmarSubmit || "Deseja salvar as alterações?"}
                visible={state.exibirModalConfirmarSubmit}
                handleYes={() => {
                    if (state.submitPendente) {
                        state.submitPendente();
                    }

                    setState((prev) => ({
                        ...prev,
                        submitPendente: null,
                        exibirModalConfirmarSubmit: false,
                    }));
                }}
                handleNo={() =>
                    setState((prev) => ({
                        ...prev,
                        submitPendente: null,
                        exibirModalConfirmarSubmit: false,
                    }))
                }
            />
            <YesNoModal
                title="Deseja permanecer nesta tela?"
                visible={state.exibirModalSairTela}
                handleYes={() => setState({ ...state, exibirModalSairTela: false })}
                handleNo={() => {
                    props.getListaUCsCliente(props.ucFormularioValues.id_cliente, null, {});
                    setState({ ...state, exibirModalSairTela: false });
                }}
            />
            <YesNoModal
                title="Você fez alterações na UC de Energia. Quer continuar aqui para salvá-las?"
                visible={state.exibirModalAlteracaoUcTrocaAba}
                handleYes={() => {
                    focarBotaoSubmit();
                    setState({ ...state, exibirModalAlteracaoUcTrocaAba: false });
                }}
                handleNo={() => {
                    props.initUcForm({ ...state.ucOriginal });
                    setState({ ...state, exibirModalAlteracaoUcTrocaAba: false, abaEnergiaAtiva: false, abaAguaAtiva: true });
                }}
            />

            <YesNoModal
                title="Você fez alterações na UC de Energia. Quer continuar aqui para salvá-las?"
                visible={state.exibirModalAlteracaoUcVoltar}
                handleYes={() => {
                    focarBotaoSubmit();
                    setState({ ...state, exibirModalAlteracaoUcVoltar: false });
                }}
                handleNo={() => {
                    props.initUcForm({ ...state.ucOriginal });
                    props.getListaUCsCliente(props.ucFormularioValues.id_cliente);
                    setState({ ...state, exibirModalAlteracaoUcVoltar: false });
                }}
            />
            <Form event={props.handleSubmit(submitComCallback)}>
                <ContentCardBody style={{ display: "flex", justifyContent: "center" }}>
                    <Grid cols="12 12 10 10" style={{ border: "1px solid #d8d8d8", borderRadius: 10, padding: 0 }}>
                        <Row style={{ padding: 10 }}>
                            <LabelAndInput
                                name="cpf_cnpj"
                                label="CPF/CNPJ"
                                placeholder="Informe o CPF ou o CNPJ"
                                cols={usuarioPodeEditarAcessos ? "10 10 10 10 " : "12 12 12 12"}
                                readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "cpf_cnpj") && readOnly}
                                value={props.ucFormularioValues.cpf_cnpj}
                                maxLength={14}
                                onChange={(data) => {
                                    props.initUcForm({
                                        ...props.ucFormularioValues,
                                        cpf_cnpj: (data.target.value || "").match(/\d{0,14}/g)[0] || null,
                                    });
                                }}
                            />
                            {usuarioPodeEditarAcessos && (
                                <Grid cols={"2 2 2 2"} style={{ paddingTop: 28 }}>
                                    <BotaoEditarCampoUc
                                        campoEdicao={state.campoEdicao}
                                        nomeCampo={"cpf_cnpj"}
                                        eventoEditar={() => setState({ ...state, campoEdicao: "cpf_cnpj" })}
                                        eventoCancelar={() => {
                                            props.initUcForm({ ...props.ucFormularioValues, cpf_cnpj: state.ucOriginal.cpf_cnpj });
                                            setState({ ...state, campoEdicao: null });
                                        }}
                                        eventoSalvar={() => {
                                            const submitPendente = () =>
                                                props.alterarPropriedadeUC({
                                                    id: props.ucFormularioValues.id,
                                                    propriedade: "cpf_cnpj",
                                                    cpf_cnpj: props.ucFormularioValues.cpf_cnpj,
                                                    id_concessionaria: props.ucFormularioValues.id_concessionaria,
                                                    callback: () =>
                                                        setState((prev) => ({
                                                            ...prev,
                                                            campoEdicao: null,
                                                            ucOriginal: {
                                                                ...state.ucOriginal,
                                                                cpf_cnpj: props.ucFormularioValues.cpf_cnpj,
                                                            },
                                                        })),
                                                });

                                            setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                        }}
                                    />
                                </Grid>
                            )}
                        </Row>
                        <Field name="nome" component={LabelAndInput} label="Nome" placeholder="Informe o nome" cols="12 12 12 12" readOnly={readOnly} />
                        <Select
                            name="id_estado"
                            options={props.listaEstado.filter((estado) => props.listaTributacao.find((tributacao) => tributacao.id_estado == estado.id))}
                            label="UF"
                            cols="12 12 12 12"
                            readOnly={readOnly}
                            isClearable={false}
                            placeholder="Selecione a UF"
                            value={props.ucFormularioValues.id_estado}
                            onChange={(data) => {
                                props.initUcForm({
                                    ...props.ucFormularioValues,
                                    id_estado: data,
                                    id_atividade: null,
                                });
                            }}
                        />
                        <Select
                            name="id_atividade"
                            options={props.listaAtividade.filter((atividade) =>
                                props.listaTributacao
                                    .filter((tributacao) => tributacao.id_estado == props.ucFormularioValues.id_estado)
                                    .find((tributacao) => tributacao.id_atividade == atividade.id)
                            )}
                            label="Tipo de Atividade"
                            cols="12 12 12 12"
                            placeholder="Selecione a atividade"
                            readOnly={readOnly}
                            isClearable={false}
                            value={props.ucFormularioValues.id_atividade}
                            onChange={(data) => {
                                props.initUcForm({
                                    ...props.ucFormularioValues,
                                    id_atividade: data,
                                    contrato_demanda_sazonal:
                                        (data == 2 && [1, 4].includes(parseInt(props.ucFormularioValues.id_grupo_faturamento))) ||
                                        props.ucFormularioValues.contrato_demanda_sazonal,
                                });
                            }}
                        />
                        <Row style={{ paddingInline: 7, marginTop: 60 }}>
                            <Grid cols="6 6 6 6" style={getEstiloAba(state.abaEnergiaAtiva)} onClick={() => setState({ ...state, abaEnergiaAtiva: true, abaAguaAtiva: false })}>
                                <h6>
                                    Energia <img style={{ marginLeft: 5 }} src={imagemLampada} height={25} alt="" />
                                </h6>
                            </Grid>
                            <Grid
                                cols="6 6 6 6"
                                style={getEstiloAba(state.abaAguaAtiva)}
                                onClick={() => {
                                    if (validarAlteracoesFormulario()) {
                                        setState({ ...state, exibirModalAlteracaoUcTrocaAba: true });
                                    } else {
                                        setState({ ...state, abaEnergiaAtiva: false, abaAguaAtiva: true });
                                    }
                                }}
                            >
                                <h6>
                                    Água <img style={{ marginLeft: 5 }} src={imagemGota} height={20} alt="" />{" "}
                                </h6>
                            </Grid>
                        </Row>

                        {state.abaEnergiaAtiva && (
                            <Grid cols="12 12 12 12" style={{ paddingBlock: 20, paddingInline: 5 }}>
                                <Select
                                    name="id_concessionaria"
                                    options={props.listaConcessionaria}
                                    label="Concessionária"
                                    cols="12 12 12 12"
                                    placeholder="Selecione a concessionaria"
                                    readOnly={readOnly}
                                    isClearable={false}
                                    value={props.ucFormularioValues.id_concessionaria}
                                    onChange={(data) => {
                                        props.initUcForm({
                                            ...props.ucFormularioValues,
                                            id_concessionaria: data,
                                            digito: data != 9 ? null : props.ucFormularioValues.digito,
                                        });
                                    }}
                                />
                                <Select
                                    name="id_gestor_concessionaria_energia"
                                    options={props.listaGestorConcessionaria.filter(
                                        (gc) => gc.id_tipo_concessionaria == 1 && gc.id_concessionaria_energia == props.ucFormularioValues.id_concessionaria
                                    )}
                                    label="Gestor da Concessionária"
                                    cols="12 12 12 12"
                                    placeholder="Selecione o gestor da concessionaria"
                                    readOnly={readOnly}
                                    isClearable={true}
                                    value={props.ucFormularioValues.id_gestor_concessionaria_energia}
                                    onChange={(data) => {
                                        props.initUcForm({
                                            ...props.ucFormularioValues,
                                            id_gestor_concessionaria_energia: data,
                                        });
                                    }}
                                />
                                <Row
                                    style={
                                        usuarioPodeEditarCodigoUC
                                            ? {
                                                  border: "1px solid #DDD",
                                                  borderRadius: 10,
                                                  margin: "30px 2px",
                                                  padding: 15,
                                              }
                                            : { paddingLeft: 7 }
                                    }
                                >
                                    <Field
                                        name="numero"
                                        component={LabelAndInput}
                                        label="Código Vigente da UC"
                                        placeholder="Informe o código"
                                        cols={"12 12 3 3"}
                                        readOnly={(!usuarioPodeEditarCodigoUC || state.campoEdicao !== "numero") && readOnly}
                                    />

                                    <Grid cols="12 12 2 2">
                                        <Button
                                            style={{ marginTop: window.innerWidth <= 768 ? 0 : 28 }}
                                            solid={false}
                                            text={"Encerrar"}
                                            icon={`fas fa-ban`}
                                            disabled={(readOnly && (!usuarioPodeEditarCodigoUC || state.campoEdicao !== "numero")) || !props.ucFormularioValues.numero}
                                            type={"danger"}
                                            event={() => {
                                                const numeroAnterior = {
                                                    numero: props.ucFormularioValues.numero,
                                                    datahora_inclusao: DateFormat.formatNewDateToSql(),
                                                };
                                                props.initUcForm({
                                                    ...props.ucFormularioValues,
                                                    numero: null,
                                                    numeros_anteriores: [...props.ucFormularioValues.numeros_anteriores, numeroAnterior],
                                                });
                                            }}
                                        />
                                    </Grid>

                                    <Grid cols={usuarioPodeEditarCodigoUC ? "12 12 5 5" : "12 12 7 7"}>
                                        <h6>Códigos Anteriores da UC</h6>
                                        <ul>
                                            {props.ucFormularioValues.numeros_anteriores.length ? (
                                                props.ucFormularioValues.numeros_anteriores.map((na, i, listaNumeros) => (
                                                    <li>
                                                        <div className="d-flex">
                                                            <div className="d-flex flex-grow-1 align-items-center" style={{ height: 40 }}>
                                                                {"Número: " + na.numero + " - Encerrado em: " + DateFormat.formatSqlToScreen(na.datahora_inclusao)}
                                                            </div>
                                                            {i == listaNumeros.length - 1 ? (
                                                                <Button
                                                                    style={{ width: 120 }}
                                                                    solid={false}
                                                                    text={"Reverter"}
                                                                    icon={`fas fa-angle-double-left`}
                                                                    disabled={readOnly && (!usuarioPodeEditarCodigoUC || state.campoEdicao !== "numero")}
                                                                    type={"success"}
                                                                    event={() => {
                                                                        props.initUcForm({
                                                                            ...props.ucFormularioValues,
                                                                            numero: na.numero,
                                                                            numeros_anteriores: [
                                                                                ...props.ucFormularioValues.numeros_anteriores.filter((el) => el.numero != na.numero),
                                                                            ],
                                                                        });
                                                                    }}
                                                                />
                                                            ) : null}
                                                        </div>
                                                    </li>
                                                ))
                                            ) : (
                                                <li>
                                                    <div className="d-flex flex-grow-1 align-items-center" style={{ height: 40 }}>
                                                        {"Não há códigos anteriores"}
                                                    </div>
                                                </li>
                                            )}
                                        </ul>
                                    </Grid>
                                    {usuarioPodeEditarCodigoUC && (
                                        <Grid cols={"12 12 2 2"} style={{ paddingTop: 28 }}>
                                            <BotaoEditarCampoUc
                                                style={{ marginTop: 0 }}
                                                campoEdicao={state.campoEdicao}
                                                nomeCampo={"numero"}
                                                eventoEditar={() => setState({ ...state, campoEdicao: "numero" })}
                                                eventoCancelar={() => {
                                                    props.initUcForm({
                                                        ...props.ucFormularioValues,
                                                        numero: state.ucOriginal.numero,
                                                        numeros_anteriores: state.ucOriginal.numeros_anteriores,
                                                    });
                                                    setState({ ...state, campoEdicao: null });
                                                }}
                                                eventoSalvar={() => {
                                                    const submitPendente = () => {
                                                        props.alterarPropriedadeUC({
                                                            id: props.ucFormularioValues.id,
                                                            propriedade: "numero",
                                                            numero: props.ucFormularioValues.numero,
                                                        });
                                                        props.alterarPropriedadeUC({
                                                            id: props.ucFormularioValues.id,
                                                            propriedade: "numeros_anteriores",
                                                            numeros_anteriores: props.ucFormularioValues.numeros_anteriores,
                                                            callback: () =>
                                                                setState((prev) => ({
                                                                    ...prev,
                                                                    campoEdicao: null,
                                                                    ucOriginal: {
                                                                        ...state.ucOriginal,
                                                                        numero: props.ucFormularioValues.numero,
                                                                        numeros_anteriores: props.ucFormularioValues.numeros_anteriores,
                                                                    },
                                                                })),
                                                        });
                                                    };
                                                    setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </Row>

                                <LabelAndInput label="(% ICMS)" cols="12 12 12 12" readOnly={true} key={aliquota_icms} value={aliquota_icms ? aliquota_icms + " %" : null} />
                                <Row style={{ paddingInline: 5 }}>
                                    <Select
                                        name="id_grupo_faturamento"
                                        options={props.listaGrupoFaturamento}
                                        label="Grupo de Faturamento"
                                        cols="12 12 6 6"
                                        placeholder="Selecione o grupo de faturamento"
                                        readOnly={readOnly}
                                        isClearable={false}
                                        value={props.ucFormularioValues.id_grupo_faturamento}
                                        onChange={(data) => {
                                            const valor = parseInt(data);
                                            //o tipo 4 é o mesmo do 1, tanto que ao salvar ele altera 4 para 1, porem com o atributo grupo_faturamento_optante = true
                                            props.initUcForm({
                                                ...props.ucFormularioValues,
                                                id_grupo_faturamento: valor,
                                                id_subgrupo_faturamento: null,
                                                contrato_demanda_sazonal:
                                                    [1, 4].includes(valor) && (props.ucFormularioValues.id_atividade == 2 || props.ucFormularioValues.contrato_demanda_sazonal),
                                                id_modalidade_tarifaria: [1, 4].includes(valor) ? props.ucFormularioValues.id_modalidade_tarifaria : null,
                                                //SE FOR GRUPO A ou IRRIGANTE é Média Tensão (id = 2) senão é Baixa Tensão (id=1)
                                                id_tipo_medicao: !props.ucFormularioValues.id
                                                    ? [1, 4].includes(valor) || props.ucFormularioValues.irrigante
                                                        ? 2
                                                        : 1
                                                    : props.ucFormularioValues.id_tipo_medicao,
                                                id_tipo_transformador: valor == 2 ? 2 : 1,
                                            });
                                        }}
                                    />
                                    <Select
                                        name="id_subgrupo_faturamento"
                                        options={props.listaSubgrupoFaturamento.filter((item) =>
                                            item.ids_grupo_faturamento.includes(props.ucFormularioValues.id_grupo_faturamento)
                                        )}
                                        label="Subgrupo de Faturamento"
                                        cols="12 12 6 6"
                                        placeholder="Selecione o subgrupo de faturamento"
                                        style={{
                                            boxShadow: props.ucFormularioValues.id && !props.ucFormularioValues.id_subgrupo_faturamento ? "0px 0px 3px 1px #ff2929" : null,
                                            borderRadius: props.ucFormularioValues.id && !props.ucFormularioValues.id_subgrupo_faturamento ? 5 : null,
                                            padding: props.ucFormularioValues.id && !props.ucFormularioValues.id_subgrupo_faturamento ? 5 : null,
                                        }}
                                        readOnly={readOnly || !props.ucFormularioValues.id_grupo_faturamento}
                                        isClearable={false}
                                        value={props.ucFormularioValues.id_subgrupo_faturamento}
                                        onChange={(data) => {
                                            const valor = parseInt(data);
                                            //o tipo 4 é o mesmo do 1, tanto que ao salvar ele altera 4 para 1, porem com o atributo grupo_faturamento_optante = true
                                            props.initUcForm({
                                                ...props.ucFormularioValues,
                                                id_subgrupo_faturamento: valor,
                                            });
                                        }}
                                    />
                                </Row>
                                <Row style={{ paddingInline: 5 }}>
                                    {!props.ucFormularioValues.id_grupo_faturamento && (
                                        <small style={{ padding: 8, color: "#FF2929" }}>Selecione o grupo de faturamento para selecionar o tipo de transformador</small>
                                    )}
                                    <Select
                                        name="id_tipo_transformador"
                                        options={props.listaTipoTransformador.filter(
                                            (item) =>
                                                props.ucFormularioValues.id_grupo_faturamento &&
                                                (props.ucFormularioValues.id_grupo_faturamento == 2 || (props.ucFormularioValues.id_grupo_faturamento != 2 && item.id == 1))
                                        )}
                                        label="Tipo de Transformador"
                                        cols={"12 12 12 12"}
                                        placeholder="Selecione o tipo de transformador"
                                        readOnly={readOnly}
                                        isClearable={false}
                                        value={props.ucFormularioValues.id_tipo_transformador}
                                        onChange={(data) => {
                                            props.initUcForm({
                                                ...props.ucFormularioValues,
                                                id_tipo_transformador: data,
                                            });
                                        }}
                                    />
                                </Row>
                                <Row style={{ paddingInline: 5 }}>
                                    <Select
                                        name="id_tipo_mercado"
                                        options={props.listaTipoMercado}
                                        label="Tipo de Mercado"
                                        cols={props.ucFormularioValues.id_tipo_mercado == 2 ? "12 12 6 6" : "12 12 12 12"}
                                        placeholder="Selecione o tipo de mercado"
                                        readOnly={readOnly}
                                        isClearable={false}
                                        value={props.ucFormularioValues.id_tipo_mercado}
                                        onChange={(data) => {
                                            props.initUcForm({
                                                ...props.ucFormularioValues,
                                                id_tipo_mercado: data,
                                                id_plataforma_mercado_livre: data == 2 ? props.ucFormularioValues.id_plataforma_mercado_livre : null,
                                                usuario_mercado_livre: data == 2 ? props.ucFormularioValues.usuario_mercado_livre : null,
                                                senha_mercado_livre: data == 2 ? props.ucFormularioValues.senha_mercado_livre : null,
                                                id_modalidade_mercado_livre: data == 2 ? props.ucFormularioValues.id_modalidade_mercado_livre : null,
                                                id_tipo_energia_mercado_livre: data == 2 ? props.ucFormularioValues.id_tipo_energia_mercado_livre : null,
                                                competencia_inicio_mercado_livre: data == 2 ? props.ucFormularioValues.competencia_inicio_mercado_livre : null,
                                                percentual_mercado_livre: data == 2 ? props.ucFormularioValues.percentual_mercado_livre : null,
                                                unidades_filhas_mercado_livre: data == 2 ? props.ucFormularioValues.unidades_filhas_mercado_livre : [],
                                            });

                                            if (data != 2) {
                                                setState({
                                                    ...state,
                                                    exibirUnidadesFilhasMercadoLivre: false,
                                                });
                                            }
                                        }}
                                    />
                                    {props.ucFormularioValues.id_tipo_mercado == 2 && (
                                        <Field
                                            name="competencia_inicio_mercado_livre"
                                            component={LabelAndInputMask}
                                            label="Mês de início no Mercado Livre (1ª Fatura M.L.)"
                                            placeholder={"Ex: 01/" + new Date().getFullYear()}
                                            cols="12 12 6 6"
                                            mask="99/9999"
                                            readOnly={readOnly}
                                            style={{
                                                boxShadow: !props.ucFormularioValues.competencia_inicio_mercado_livre ? "0px 0px 3px 1px #ff2929" : null,
                                                borderRadius: !props.ucFormularioValues.competencia_inicio_mercado_livre ? 5 : null,
                                                padding: !props.ucFormularioValues.competencia_inicio_mercado_livre ? 5 : null,
                                            }}
                                        />
                                    )}
                                </Row>
                                {props.ucFormularioValues.id_tipo_mercado == 2 ? (
                                    <>
                                        <LabelAndCheckbox
                                            style={{ paddingBlock: 20 }}
                                            title={{
                                                marcado: "Esta unidade está faturando o consumo de múltiplas unidades consumidoras",
                                                desmarcado: "Esta unidade não está faturando o consumo de múltiplas unidades consumidoras",
                                            }}
                                            label="Recebe nota referente ao consumo de um grupo de unidades consumidoras (Unidade Mercado Livre - MÃE)"
                                            cols="12 12 12 12"
                                            readOnly={readOnly}
                                            value={!!state.exibirUnidadesFilhasMercadoLivre}
                                            onChange={() => {
                                                setState({
                                                    ...state,
                                                    exibirUnidadesFilhasMercadoLivre: !state.exibirUnidadesFilhasMercadoLivre,
                                                });
                                                props.initUcForm({
                                                    ...props.ucFormularioValues,
                                                    unidades_filhas_mercado_livre: [],
                                                });
                                            }}
                                        />
                                        {state.exibirUnidadesFilhasMercadoLivre && (
                                            <Row style={{ marginBottom: 30, marginInline: 10, border: "1px solid #EEE", padding: 20, backgroundColor: "#FAFAFA" }}>
                                                <Grid cols="12 12 12 12">
                                                    <Row style={{ padding: 10, fontWeight: "bolder" }}>Unidades Faturadas pela mesma nota (Unidades Mercado Livre - FILHAS)</Row>
                                                    <Row>
                                                        <Select
                                                            options={listaUCsMercadoLivre}
                                                            label=""
                                                            cols="12 12 8 9"
                                                            placeholder="Selecione a unidade consumidora Mercado Livre (FILHA)"
                                                            readOnly={readOnly}
                                                            isClearable={false}
                                                            value={state.idUcFilhaMercadoLivre}
                                                            onChange={(data) => {
                                                                setState({ ...state, idUcFilhaMercadoLivre: data });
                                                            }}
                                                        />
                                                        <Grid cols="12 12 4 3" style={{ paddingBottom: 10 }}>
                                                            <Button
                                                                text="Incluir Unidade M.L. Filha"
                                                                type={"primary"}
                                                                icon={"fa fa-plus"}
                                                                disabled={readOnly || !state.idUcFilhaMercadoLivre}
                                                                style={{ marginLeft: 0 }}
                                                                event={() => {
                                                                    const ucSelecionada = listaUCsMercadoLivre.find((uc) => uc.id == state.idUcFilhaMercadoLivre);
                                                                    props.initUcForm({
                                                                        ...props.ucFormularioValues,
                                                                        unidades_filhas_mercado_livre: [
                                                                            ...props.ucFormularioValues.unidades_filhas_mercado_livre,
                                                                            {
                                                                                id_unidade_consumidora: state.idUcFilhaMercadoLivre,
                                                                                nome_unidade_consumidora: ucSelecionada.valor,
                                                                            },
                                                                        ],
                                                                    });
                                                                    setState({ ...state, idUcFilhaMercadoLivre: null });
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Row>
                                                </Grid>
                                                <Table responsive>
                                                    <THead>
                                                        <Tr>
                                                            <Th>Unidade Consumidora</Th>
                                                        </Tr>
                                                    </THead>
                                                    <TBody>
                                                        {props.ucFormularioValues.unidades_filhas_mercado_livre.map((uc) => (
                                                            <NewTr
                                                                key={uc.id_unidade_consumidora}
                                                                botoes={[
                                                                    {
                                                                        type: "danger",
                                                                        icon: "fas fa-trash-alt",
                                                                        disabled: readOnly,
                                                                        event: () => {
                                                                            props.initUcForm({
                                                                                ...props.ucFormularioValues,
                                                                                unidades_filhas_mercado_livre: props.ucFormularioValues.unidades_filhas_mercado_livre.filter(
                                                                                    (el) => el.id_unidade_consumidora != uc.id_unidade_consumidora
                                                                                ),
                                                                            });
                                                                        },
                                                                    },
                                                                ]}
                                                            >
                                                                <Td>{uc.nome_unidade_consumidora}</Td>
                                                            </NewTr>
                                                        ))}
                                                    </TBody>
                                                </Table>
                                            </Row>
                                        )}
                                        <Select
                                            name="id_modalidade_mercado_livre"
                                            options={props.listaModalidadeMercadoLivre}
                                            label="Modalidade de Mercado Livre"
                                            cols="12 12 12 12"
                                            placeholder="Selecione a modalidade de mercado livre"
                                            readOnly={readOnly}
                                            isClearable={false}
                                            value={props.ucFormularioValues.id_modalidade_mercado_livre}
                                            onChange={(data) => {
                                                props.initUcForm({
                                                    ...props.ucFormularioValues,
                                                    id_modalidade_mercado_livre: data,
                                                    id_tipo_energia_mercado_livre: null,
                                                    percentual_mercado_livre: null,
                                                });
                                            }}
                                        />
                                        {props.ucFormularioValues.id_modalidade_mercado_livre ? (
                                            <Grid cols="12 12 12 12" style={{ padding: "0px 15px 15px 15px" }}>
                                                <Row
                                                    style={{
                                                        border: "1px solid #DDD",
                                                        borderRadius: 15,
                                                        padding: "10px 10px 0px 0px ",
                                                    }}
                                                >
                                                    <Grid cols="12 12 12 12">
                                                        <label>Contratos Mercado Livre</label>
                                                    </Grid>
                                                    <Select
                                                        name="id_tipo_energia_mercado_livre"
                                                        options={props.listaTipoEnergiaMercadoLivre.filter(
                                                            (tipo) =>
                                                                //varejo aceita todos
                                                                props.ucFormularioValues.id_modalidade_mercado_livre == 2 || [1, 2].includes(tipo.id) //1 e 2 é com incentivo e sem incentivo, pq atacado só aceita esses 2
                                                        )}
                                                        label="Tipo de Energia Mercado Livre"
                                                        cols={
                                                            !props.ucFormularioValues.id_modalidade_mercado_livre || props.ucFormularioValues.id_modalidade_mercado_livre == 2
                                                                ? "12 12 12 12"
                                                                : "12 12 8 8"
                                                        }
                                                        placeholder="Selecione o tipo de energia mercado livre"
                                                        readOnly={readOnly}
                                                        isClearable={false}
                                                        value={props.ucFormularioValues.id_tipo_energia_mercado_livre}
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                id_tipo_energia_mercado_livre: parseInt(data),
                                                            });
                                                        }}
                                                    />
                                                    {
                                                        //com incentivo ou energia garantida precisa de percentual
                                                        [1, 3].includes(props.ucFormularioValues.id_tipo_energia_mercado_livre) ? (
                                                            <LabelAndInputNumber
                                                                allowNegative={false}
                                                                name="percentual_mercado_livre"
                                                                label="Percentual Mercado Livre (%)"
                                                                cols="12 12 4 4"
                                                                placeholder="Informe o percentual"
                                                                readOnly={readOnly}
                                                                casas={2}
                                                                value={String(props.ucFormularioValues.percentual_mercado_livre).replace(".", ",")}
                                                                onChange={(data) => {
                                                                    props.initUcForm({
                                                                        ...props.ucFormularioValues,
                                                                        percentual_mercado_livre: parseFloat(String(data.target.value).replace(",", ".")) || 0,
                                                                    });
                                                                }}
                                                            />
                                                        ) : null
                                                    }
                                                </Row>
                                            </Grid>
                                        ) : null}

                                        <Grid cols="12 12 12 12" style={{ padding: "0px 15px 15px 15px" }}>
                                            <Row
                                                style={{
                                                    border: "1px solid #DDD",
                                                    borderRadius: 15,
                                                    padding: "10px 10px 0px 0px ",
                                                }}
                                            >
                                                <Grid cols={usuarioPodeEditarAcessos ? "10 10 10 10" : "12 12 12 12"} style={{ margin: 0 }}>
                                                    <Grid cols="12 12 12 12">
                                                        <label>Acesso Plataforma Mercado Livre</label>
                                                    </Grid>

                                                    <Field
                                                        component={Select}
                                                        name="id_plataforma_mercado_livre"
                                                        options={props.listaPlataformaMercadoLivre}
                                                        label="Plataforma Mercado Livre"
                                                        cols={"12 12 12 12"}
                                                        placeholder="Selecione a plataforma"
                                                        readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "id_plataforma_mercado_livre") && readOnly}
                                                        isClearable={false}
                                                    />
                                                    {state.exibirUsuarioSenhaMercadoLivre ? (
                                                        <>
                                                            <Field
                                                                component={LabelAndInput}
                                                                name="usuario_mercado_livre"
                                                                label="Login"
                                                                placeholder="Informe o login"
                                                                cols={"12 12 12 12"}
                                                                readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "usuario_mercado_livre") && readOnly}
                                                            />

                                                            <Field
                                                                component={LabelAndInput}
                                                                name="senha_mercado_livre"
                                                                label="Senha"
                                                                placeholder="Informe o senha"
                                                                cols={"12 12 12 12"}
                                                                readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "senha_mercado_livre") && readOnly}
                                                            />
                                                        </>
                                                    ) : null}
                                                </Grid>
                                                {usuarioPodeEditarAcessos && (
                                                    <Grid cols={"2 2 2 2"} style={{ paddingTop: 28 }}>
                                                        <BotaoEditarCampoUc
                                                            style={{ marginTop: 32 }}
                                                            campoEdicao={state.campoEdicao}
                                                            nomeCampo={"id_plataforma_mercado_livre"}
                                                            eventoEditar={() => setState({ ...state, campoEdicao: "id_plataforma_mercado_livre" })}
                                                            eventoCancelar={() => {
                                                                props.initUcForm({
                                                                    ...props.ucFormularioValues,
                                                                    id_plataforma_mercado_livre: state.ucOriginal.id_plataforma_mercado_livre,
                                                                });
                                                                setState({ ...state, campoEdicao: null });
                                                            }}
                                                            eventoSalvar={() => {
                                                                const submitPendente = () => {
                                                                    props.alterarPropriedadeUC({
                                                                        id: props.ucFormularioValues.id,
                                                                        propriedade: "id_plataforma_mercado_livre",
                                                                        id_plataforma_mercado_livre: props.ucFormularioValues.id_plataforma_mercado_livre,
                                                                        callback: () =>
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                campoEdicao: null,
                                                                                ucOriginal: {
                                                                                    ...state.ucOriginal,
                                                                                    id_plataforma_mercado_livre: props.ucFormularioValues.id_plataforma_mercado_livre,
                                                                                },
                                                                            })),
                                                                    });
                                                                };
                                                                setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                            }}
                                                        />
                                                        {state.exibirUsuarioSenhaMercadoLivre ? (
                                                            <>
                                                                <BotaoEditarCampoUc
                                                                    style={{ marginTop: 42 }}
                                                                    campoEdicao={state.campoEdicao}
                                                                    nomeCampo={"usuario_mercado_livre"}
                                                                    eventoEditar={() => setState({ ...state, campoEdicao: "usuario_mercado_livre" })}
                                                                    eventoCancelar={() => {
                                                                        props.initUcForm({
                                                                            ...props.ucFormularioValues,
                                                                            usuario_mercado_livre: state.ucOriginal.usuario_mercado_livre,
                                                                        });
                                                                        setState({ ...state, campoEdicao: null });
                                                                    }}
                                                                    eventoSalvar={() => {
                                                                        const submitPendente = () => {
                                                                            props.alterarPropriedadeUC({
                                                                                id: props.ucFormularioValues.id,
                                                                                propriedade: "usuario_mercado_livre",
                                                                                usuario_mercado_livre: props.ucFormularioValues.usuario_mercado_livre,
                                                                                callback: () =>
                                                                                    setState((prev) => ({
                                                                                        ...prev,
                                                                                        campoEdicao: null,
                                                                                        ucOriginal: {
                                                                                            ...state.ucOriginal,
                                                                                            usuario_mercado_livre: props.ucFormularioValues.usuario_mercado_livre,
                                                                                        },
                                                                                    })),
                                                                            });
                                                                        };
                                                                        setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                                    }}
                                                                />
                                                                <BotaoEditarCampoUc
                                                                    style={{ marginTop: 42 }}
                                                                    campoEdicao={state.campoEdicao}
                                                                    nomeCampo={"senha_mercado_livre"}
                                                                    eventoEditar={() => setState({ ...state, campoEdicao: "senha_mercado_livre" })}
                                                                    eventoCancelar={() => {
                                                                        props.initUcForm({
                                                                            ...props.ucFormularioValues,
                                                                            senha_mercado_livre: state.ucOriginal.senha_mercado_livre,
                                                                        });
                                                                        setState({ ...state, campoEdicao: null });
                                                                    }}
                                                                    eventoSalvar={() => {
                                                                        const submitPendente = () => {
                                                                            props.alterarPropriedadeUC({
                                                                                id: props.ucFormularioValues.id,
                                                                                propriedade: "senha_mercado_livre",
                                                                                senha_mercado_livre: props.ucFormularioValues.senha_mercado_livre,
                                                                                callback: () =>
                                                                                    setState((prev) => ({
                                                                                        ...prev,
                                                                                        campoEdicao: null,
                                                                                        ucOriginal: {
                                                                                            ...state.ucOriginal,
                                                                                            senha_mercado_livre: props.ucFormularioValues.senha_mercado_livre,
                                                                                        },
                                                                                    })),
                                                                            });
                                                                        };
                                                                        setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                                    }}
                                                                />
                                                            </>
                                                        ) : null}
                                                    </Grid>
                                                )}
                                            </Row>
                                        </Grid>
                                    </>
                                ) : null}

                                <Grid cols="12 12 12 12" style={{ padding: "0px 15px 15px 15px", marginBlock: 10 }}>
                                    <Row
                                        style={{
                                            border: "1px solid #DDD",
                                            borderRadius: 15,
                                            padding: "10px 10px 0px 0px ",
                                        }}
                                    >
                                        <Grid cols={usuarioPodeEditarAcessos ? "10 10 10 10" : "12 12 12 12"} style={{ margin: 0 }}>
                                            <Grid cols="12 12 12 12">
                                                <label>Acesso Concessionária de Energia</label>
                                            </Grid>
                                            <Row style={{ paddingInline: 7 }}>
                                                <Field
                                                    component={LabelAndInput}
                                                    name="usuario"
                                                    label="Login"
                                                    placeholder="Informe o login"
                                                    cols={"12 12 12 12"}
                                                    readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "usuario") && readOnly}
                                                />
                                            </Row>

                                            <Field
                                                component={LabelAndInput}
                                                name="senha"
                                                label="Senha"
                                                placeholder="Informe o senha"
                                                cols="12 12 12 12"
                                                readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "senha") && readOnly}
                                            />

                                            {(!props.visualizar || props.ucFormularioValues.data_nascimento) && (
                                                <Field
                                                    component={LabelAndInput}
                                                    name="data_nascimento"
                                                    label="Data de Nascimento"
                                                    type="date"
                                                    format={(valor) => valor ? String(valor).substring(0, 10) : ""}
                                                    cols="12 12 12 12"
                                                    readOnly={(!usuarioPodeEditarAcessos || state.campoEdicao !== "data_nascimento") && readOnly}
                                                />
                                            )}
                                        </Grid>
                                        {usuarioPodeEditarAcessos && (
                                            <Grid cols={"2 2 2 2"} style={{ paddingTop: 28 }}>
                                                <BotaoEditarCampoUc
                                                    style={{ marginTop: 32 }}
                                                    campoEdicao={state.campoEdicao}
                                                    nomeCampo={"usuario"}
                                                    eventoEditar={() => setState({ ...state, campoEdicao: "usuario" })}
                                                    eventoCancelar={() => {
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            usuario: state.ucOriginal.usuario,
                                                        });
                                                        setState({ ...state, campoEdicao: null });
                                                    }}
                                                    eventoSalvar={() => {
                                                        const submitPendente = () => {
                                                            props.alterarPropriedadeUC({
                                                                id: props.ucFormularioValues.id,
                                                                propriedade: "usuario",
                                                                usuario: props.ucFormularioValues.usuario,
                                                                digito: null,
                                                                id_concessionaria: props.ucFormularioValues.id_concessionaria,
                                                                callback: () =>
                                                                    setState((prev) => ({
                                                                        ...prev,
                                                                        campoEdicao: null,
                                                                        ucOriginal: {
                                                                            ...state.ucOriginal,
                                                                            usuario: props.ucFormularioValues.usuario,
                                                                        },
                                                                    })),
                                                            });
                                                        };
                                                        setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                    }}
                                                />
                                                <BotaoEditarCampoUc
                                                    style={{ marginTop: 51 }}
                                                    campoEdicao={state.campoEdicao}
                                                    nomeCampo={"senha"}
                                                    eventoEditar={() => setState({ ...state, campoEdicao: "senha" })}
                                                    eventoCancelar={() => {
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            senha: state.ucOriginal.senha,
                                                        });
                                                        setState({ ...state, campoEdicao: null });
                                                    }}
                                                    eventoSalvar={() => {
                                                        const submitPendente = () => {
                                                            props.alterarPropriedadeUC({
                                                                id: props.ucFormularioValues.id,
                                                                propriedade: "senha",
                                                                senha: props.ucFormularioValues.senha,
                                                                callback: () =>
                                                                    setState((prev) => ({
                                                                        ...prev,
                                                                        campoEdicao: null,
                                                                        ucOriginal: {
                                                                            ...state.ucOriginal,
                                                                            senha: props.ucFormularioValues.senha,
                                                                        },
                                                                    })),
                                                                id_concessionaria: props.ucFormularioValues.id_concessionaria,
                                                            });
                                                        };
                                                        setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                    }}
                                                />
                                                <BotaoEditarCampoUc
                                                    style={{ marginTop: 51 }}
                                                    campoEdicao={state.campoEdicao}
                                                    nomeCampo={"data_nascimento"}
                                                    eventoEditar={() => setState({ ...state, campoEdicao: "data_nascimento" })}
                                                    eventoCancelar={() => {
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            data_nascimento: state.ucOriginal.data_nascimento,
                                                        });
                                                        setState({ ...state, campoEdicao: null });
                                                    }}
                                                    eventoSalvar={() => {
                                                        const submitPendente = () => {
                                                            props.alterarPropriedadeUC({
                                                                id: props.ucFormularioValues.id,
                                                                propriedade: "data_nascimento",
                                                                data_nascimento: props.ucFormularioValues.data_nascimento || null,
                                                                id_concessionaria: props.ucFormularioValues.id_concessionaria,
                                                                callback: () =>
                                                                    setState((prev) => ({
                                                                        ...prev,
                                                                        campoEdicao: null,
                                                                        ucOriginal: {
                                                                            ...prev.ucOriginal,
                                                                            data_nascimento: props.ucFormularioValues.data_nascimento || null,
                                                                        },
                                                                    })),
                                                            });
                                                        };
                                                        setState((prev) => ({ ...prev, exibirModalConfirmarSubmit: true, submitPendente }));
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Row>
                                </Grid>
                                {[1, 4].includes(parseInt(props.ucFormularioValues.id_grupo_faturamento)) ? ( //só exibe os 2 campos se for Grupo A
                                    <>
                                        <Field
                                            component={Select}
                                            name="id_modalidade_tarifaria"
                                            options={props.listaModalidadeTarifaria}
                                            label="Modalidade Tarifária (Reflexo no tipo de Contrato de Demanda)"
                                            cols="12 12 12 12"
                                            placeholder="Selecione a modalidade tarifária"
                                            readOnly={readOnly}
                                            isClearable={false}
                                        />

                                        <LabelAndCheckbox
                                            title={{
                                                marcado: "Disponível apenas para Grupo A, se for Grupo A e Atividade Rural a caixa é marcada e não pode ser alterada",
                                                desmarcado: "Disponível apenas para Grupo A, se for Grupo A e Atividade Rural a caixa é marcada e não pode ser alterada",
                                            }}
                                            label="Possui contrato de demanda Sazonal?"
                                            cols="12 12 12 12"
                                            readOnly={
                                                readOnly ||
                                                ![1, 4].includes(parseInt(props.ucFormularioValues.id_grupo_faturamento)) || //Não for grupo A
                                                ([1, 4].includes(parseInt(props.ucFormularioValues.id_grupo_faturamento)) && props.ucFormularioValues.id_atividade == 2) //se for Grupo A e Rural seta sim e n deixa editar
                                            }
                                            value={!!props.ucFormularioValues.contrato_demanda_sazonal}
                                            onChange={() => {
                                                props.initUcForm({
                                                    ...props.ucFormularioValues,
                                                    contrato_demanda_sazonal: !props.ucFormularioValues.contrato_demanda_sazonal,
                                                });
                                            }}
                                        />
                                    </>
                                ) : null}

                                <Field
                                    component={Select}
                                    name="id_tipo_medicao"
                                    options={props.listaTipoMedicao}
                                    label="Tipo de Medição"
                                    cols="12 12 12 12"
                                    placeholder="Selecione o tipo de medição"
                                    readOnly={readOnly}
                                    isClearable={false}
                                />
                                <LabelAndCheckbox
                                    // alignCenter={window.innerWidth > 991}
                                    // divMarginRight={10}
                                    title={{
                                        marcado: "Contabiliza histórico de dados das faturas até a data do desligamento",
                                        desmarcado: "Contabiliza histórico de dados das faturas durante todo o período",
                                    }}
                                    label="Desligado"
                                    cols="12 12 12 12"
                                    readOnly={readOnly}
                                    value={!!props.ucFormularioValues.mostrar_data_desligamento}
                                    onChange={() => {
                                        props.initUcForm({
                                            ...props.ucFormularioValues,
                                            mostrar_data_desligamento: !props.ucFormularioValues.mostrar_data_desligamento,
                                            data_desligamento: null,
                                        });
                                    }}
                                />
                                {props.ucFormularioValues.mostrar_data_desligamento || props.ucFormularioValues.data_desligamento ? (
                                    <Field
                                        component={LabelAndInputDate}
                                        name="data_desligamento"
                                        label="Data de Desligamento"
                                        cols="12 12 12 12"
                                        placeholder="Informe a data"
                                        readOnly={readOnly}
                                    />
                                ) : null}
                                <LabelAndCheckbox
                                    style={{ marginRight: 10 }}
                                    label="Irrigante"
                                    cols="12 12 12 12"
                                    readOnly={readOnly}
                                    value={!!props.ucFormularioValues.irrigante}
                                    onChange={() => {
                                        props.initUcForm({
                                            ...props.ucFormularioValues,
                                            irrigante: !props.ucFormularioValues.irrigante,
                                            subsidio_irrigante: !props.ucFormularioValues.irrigante && props.ucFormularioValues.subsidio_irrigante, //tem q ser irrigante pra ser true
                                            //SE FOR GRUPO A (id=1) ou SE FOR IRRIGANTE é Média Tensão (id = 2) senão é Baixa Tensão (id=1)
                                            id_tipo_medicao: !props.ucFormularioValues.id
                                                ? [1, 4].includes(parseInt(props.ucFormularioValues.id_grupo_faturamento)) || !props.ucFormularioValues.irrigante //valor do checkbox alterado
                                                    ? 2
                                                    : 1
                                                : props.ucFormularioValues.id_tipo_medicao,
                                        });
                                    }}
                                />
                                {props.ucFormularioValues.irrigante ? (
                                    <Grid
                                        cols="12 12 12 12"
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            height: "min-content",
                                            paddingInline: 20,
                                            marginBottom: 20,
                                        }}
                                    >
                                        <RadioButton
                                            nameField="Possui Subsídio Irrigante? (Outorga de água definitiva e Liberação Ambiental)"
                                            options={[
                                                {
                                                    id: "subsidio_irrigante_sim",
                                                    name: "subsidio_irrigante",
                                                    value: props.ucFormularioValues.subsidio_irrigante,
                                                    conditionChecked: props.ucFormularioValues.subsidio_irrigante,
                                                    event: (e) => {
                                                        setState({ ...state, tipoCliente: e.target.value });
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            subsidio_irrigante: true,
                                                        });
                                                    },
                                                    label: "Sim",
                                                },
                                                {
                                                    id: "subsidio_irrigante_nao",
                                                    name: "subsidio_irrigante",
                                                    value: false,
                                                    conditionChecked: !props.ucFormularioValues.subsidio_irrigante,
                                                    event: (e) => {
                                                        setState({ ...state, tipoCliente: e.target.value });
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            subsidio_irrigante: false,
                                                        });
                                                    },
                                                    label: "Não",
                                                },
                                            ]}
                                            readOnly={readOnly}
                                        />
                                    </Grid>
                                ) : null}
                                <LabelAndCheckbox
                                    style={{ marginRight: 10 }}
                                    label="Geração de Energia"
                                    cols="12 12 12 12"
                                    readOnly={readOnly}
                                    value={!!props.ucFormularioValues.mostrar_geracao_solar}
                                    onChange={() => {
                                        if (props.ucFormularioValues.remotas_alugadas.length > 0 && !!props.ucFormularioValues.mostrar_geracao_solar) {
                                            return window.alert(
                                                "Verifique na tabela abaixo que existem UCs que recebem energia desta unidade. Altere a fonte geradora das unidades remotas antes de remover a geração desta unidade"
                                            );
                                        }
                                        setState({
                                            ...state,
                                            exibirTransformarRemotaEmGeradora: false,
                                        });
                                        props.initUcForm({
                                            ...props.ucFormularioValues,
                                            mostrar_geracao_solar: !props.ucFormularioValues.mostrar_geracao_solar,
                                            geracao: !props.ucFormularioValues.mostrar_geracao_solar,
                                            remota: false,
                                            geradora_externa: false,
                                            id_unidade_geradora: null,
                                            percentual_geracao: null,
                                            id_unidade_geradora_2: null,
                                            percentual_geracao_2: null,
                                            percentual_geracao_externa: null,
                                            percentual_geracao_externa_2: null,
                                            competencia_inicio_geracao: null,
                                        });
                                    }}
                                />
                                {props.ucFormularioValues.mostrar_geracao_solar ? (
                                    <Row style={{ padding: 8 }}>
                                        <Select
                                            options={props.listaGeracaoTipo.filter((item) => state.exibirTransformarRemotaEmGeradora || item.id !== "Remota que virou Geradora")}
                                            label="Classificação de Geração"
                                            cols={
                                                exibirBotaoTransformarRemotaGeradora || state.exibirTransformarRemotaEmGeradora
                                                    ? state.exibirTransformarRemotaEmGeradora
                                                        ? "12 12 4 4"
                                                        : "12 12 8 8"
                                                    : "12 12 12 12"
                                            }
                                            placeholder="Selecione a classificação de geração"
                                            readOnly={readOnly || state.exibirTransformarRemotaEmGeradora}
                                            isClearable={false}
                                            value={state.classificacaoGeracao}
                                            onChange={(data) => {
                                                if (props.ucFormularioValues.remotas_alugadas.length > 0 && data === "Unidade Remota") {
                                                    return window.alert(
                                                        "Verifique na tabela abaixo que existem UCs que recebem energia desta unidade. Altere a fonte geradora das unidades remotas antes de remover a geração desta unidade"
                                                    );
                                                }

                                                const geradoraSelecionada = data === "Unidade Geradora (Própria)";
                                                const geradoraRemotaSelecionada = data === "Unidade Geradora/Remota";
                                                const remotaSelecionada = data === "Unidade Remota";

                                                //TODAS VEZ QUE ALTERA ZERA OS PERCENTUAIS

                                                //define objectos padrao que são definidos para cada tipo de geracao
                                                const objetoSpread = {
                                                    id_unidade_geradora: props.ucFormularioValues.id_unidade_geradora,
                                                    id_unidade_geradora_2: props.ucFormularioValues.id_unidade_geradora_2,
                                                    percentual_geracao: 0,
                                                    percentual_geracao_2: 0,
                                                    percentual_geracao_externa: 0,
                                                    percentual_geracao_externa_2: 0,
                                                };

                                                if (geradoraSelecionada) {
                                                    //unidade que é apenas geradora, só tem percentual de geracao
                                                    objetoSpread.id_unidade_geradora = null;
                                                    objetoSpread.id_unidade_geradora_2 = null;
                                                } else if (geradoraRemotaSelecionada) {
                                                    objetoSpread.id_unidade_geradora_2 = null;
                                                }

                                                //remota que virou geradora pode ter 2 id geradora apenas, para fins de histórico

                                                setState({
                                                    ...state,
                                                    classificacaoGeracao: data,
                                                });
                                                props.initUcForm({
                                                    ...props.ucFormularioValues,
                                                    geracao: geradoraSelecionada || geradoraRemotaSelecionada,
                                                    remota: remotaSelecionada,
                                                    geradora_externa: !!(props.ucFormularioValues.geracao_externa && !geradoraSelecionada),
                                                    ...objetoSpread,
                                                });
                                            }}
                                        />
                                        {exibirBotaoTransformarRemotaGeradora ? (
                                            <Grid cols="12 12 4 4" style={{ display: "flex", alignItems: "center" }}>
                                                <Button
                                                    title="Transformar em Geradora"
                                                    text="Transformar em Geradora"
                                                    hoverStyle={{ filter: "brightness(1.1)" }}
                                                    style={{
                                                        background: "linear-gradient(#7be3f4, #a3a1ff)",
                                                        margin: "10px 0px 0px",
                                                        fontSize: "0.95rem !important",
                                                        padding: 8,
                                                        height: 40,
                                                        fontWeight: 500,
                                                        border: "1px solid #87cefa",
                                                        color: "#FFF",
                                                    }}
                                                    disabled={false}
                                                    event={() => {
                                                        setState({
                                                            ...state,
                                                            exibirTransformarRemotaEmGeradora: true,
                                                            classificacaoGeracao: "Remota que virou Geradora",
                                                        });
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            geracao: true, //vira geradora mas mantem o id_unidade_geradora e id_unidade_geradora_2, para contabilizar a economia na geradora antiga
                                                            remota: false,
                                                            percentual_geracao: 0,
                                                            percentual_geracao_2: 0,
                                                            remotaVirouGeradora: true,
                                                            competencia_inicio_geracao: null,
                                                        });
                                                    }}
                                                />
                                            </Grid>
                                        ) : null}
                                        {props.ucFormularioValues.id && state.exibirTransformarRemotaEmGeradora && (
                                            <Field
                                                name="competencia_inicio_geracao"
                                                component={LabelAndInputMask}
                                                label="Mês de Início da Geração"
                                                placeholder="MM/AAAA"
                                                cols="12 12 4 4"
                                                mask="99/9999"
                                                readOnly={readOnly}
                                            />
                                        )}

                                        {props.ucFormularioValues.id && state.exibirTransformarRemotaEmGeradora && (
                                            <Grid cols="12 12 4 4" style={{ display: "flex", alignItems: "center" }}>
                                                <Button
                                                    title="Reverter para Remota"
                                                    text="Reverter para Remota"
                                                    hoverStyle={{ filter: "brightness(1.1)" }}
                                                    style={{
                                                        background: "linear-gradient(#ff536b, #edb4a2)",
                                                        margin: "10px 0px 0px",
                                                        fontSize: "0.95rem !important",
                                                        padding: 8,
                                                        height: 40,
                                                        fontWeight: 500,
                                                        border: "1px solid #ff8181",
                                                        color: "#FFF",
                                                    }}
                                                    disabled={readOnly}
                                                    event={() => {
                                                        setState({ ...state, exibirTransformarRemotaEmGeradora: false, classificacaoGeracao: "Unidade Remota" });
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            geracao: false, //vira geradora mas mantem o id_unidade_geradora, para contabilizar a economia na geradora antiga
                                                            remota: true,
                                                            remotaVirouGeradora: false,
                                                            competencia_inicio_geracao: null,
                                                        });
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                    </Row>
                                ) : null}
                                {state.classificacaoGeracao === "Unidade Geradora/Remota" && (
                                    <>
                                        <Row style={{ alignItems: "end", padding: 8 }}>
                                            <LabelAndInputNumber
                                                title="Colocar o percentual do injetado que fica da produção da própria unidade geradora"
                                                allowNegative={false}
                                                name="percentual_geracao"
                                                label={<div>Percentual da Geração Própria</div>}
                                                cols={"12 12 6 6"}
                                                placeholder="Informe o percentual de geração própria"
                                                readOnly={readOnly}
                                                casas={2}
                                                value={
                                                    parseFloat(props.ucFormularioValues.percentual_geracao) >= 0
                                                        ? String(props.ucFormularioValues.percentual_geracao).replace(".", ",")
                                                        : null
                                                }
                                                onChange={(data) => {
                                                    props.initUcForm({
                                                        ...props.ucFormularioValues,
                                                        percentual_geracao: parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                    });
                                                }}
                                            />
                                        </Row>
                                        <Row style={{ alignItems: "end", padding: 8 }}>
                                            <Grid
                                                cols="12 12 12 12"
                                                style={{
                                                    display: "flex",
                                                    flexWrap: "wrap",
                                                    height: "min-content",
                                                    marginBottom: 20,
                                                }}
                                            >
                                                <RadioButton
                                                    nameField="Selecione a forma de recebimento da energia"
                                                    options={[
                                                        {
                                                            id: "geradora_remota",
                                                            name: "possui_contrato_aluguel",
                                                            value: "geradora_remota",
                                                            conditionChecked: !props.ucFormularioValues.possui_contrato_aluguel,
                                                            event: (e) => {
                                                                // window.confirm(
                                                                //     "O valor não pode ser alterado, pois é definido com base na existência de contrato de aluguel de usina."
                                                                // );
                                                                props.initUcForm({
                                                                    ...props.ucFormularioValues,
                                                                    possui_contrato_aluguel: e.target.value === "usina_aluguel",
                                                                });
                                                            },
                                                            label: "Recebe energia de outra usina pŕopria",
                                                        },
                                                        {
                                                            id: "usina_aluguel",
                                                            name: "possui_contrato_aluguel",
                                                            value: "usina_aluguel",
                                                            conditionChecked: props.ucFormularioValues.possui_contrato_aluguel,
                                                            event: (e) => {
                                                                // window.confirm(
                                                                //     "O valor não pode ser alterado, pois é definido com base na existência de contrato de aluguel de usina."
                                                                // );
                                                                props.initUcForm({
                                                                    ...props.ucFormularioValues,
                                                                    possui_contrato_aluguel: e.target.value === "usina_aluguel",
                                                                });
                                                            },
                                                            label: "Aluga a energia de outra usina",
                                                        },
                                                    ]}
                                                    readOnly={readOnly}
                                                />
                                            </Grid>
                                        </Row>
                                        <Row>
                                            <Grid cols="12 12 6 6">
                                                <div
                                                    style={{
                                                        marginLeft: 10,
                                                        marginRight: window.innerWidth < 768 ? 10 : 5,
                                                        backgroundColor: "#EEE",
                                                        borderRadius: 5,
                                                        padding: 10,
                                                    }}
                                                >
                                                    <Select
                                                        name="id_unidade_geradora"
                                                        options={listaUCsGeradorasAtivas}
                                                        label={"Unidade Fonte Geradora 1"}
                                                        value={String(props.ucFormularioValues.id_unidade_geradora)}
                                                        cols="12 12 12 12"
                                                        placeholder="Selecione a UC"
                                                        readOnly={readOnly}
                                                        isClearable={true}
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                id_unidade_geradora: JSON.parse(data), //se é null é pq a geradora é de fora do gradios
                                                                geradora_externa: data == 0,
                                                            });
                                                        }}
                                                    />
                                                    <LabelAndInputNumber
                                                        title={`Nesse local deve colocar o percentual de energia que recebe ${
                                                            props.ucFormularioValues.possui_contrato_aluguel ? "da usina alugada" : "da outra usina própria"
                                                        }`}
                                                        allowNegative={false}
                                                        name="percentual_geracao_externa"
                                                        label={
                                                            <div>
                                                                <div style={{ color: "#F44", display: "flex", fontWeight: "bold" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    Cuidar esse item para colocar exatamento como está no Anexo G
                                                                </div>
                                                                <div className="mt-2">
                                                                    Percentual de Geração Recebido{" "}
                                                                    {props.ucFormularioValues.possui_contrato_aluguel ? "da Usina Alugada" : "da Outra Usina Própria"}
                                                                </div>
                                                            </div>
                                                        }
                                                        cols="12 12 12 12"
                                                        placeholder={`Informe o percentual de geração recebido ${
                                                            props.ucFormularioValues.possui_contrato_aluguel ? "da usina alugada" : "da outra usina própria"
                                                        }`}
                                                        readOnly={readOnly}
                                                        casas={2}
                                                        value={
                                                            parseFloat(props.ucFormularioValues.percentual_geracao_externa) >= 0
                                                                ? String(props.ucFormularioValues.percentual_geracao_externa).replace(".", ",")
                                                                : null
                                                        }
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                percentual_geracao_externa: parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                            <Grid cols="12 12 6 6">
                                                <div
                                                    style={{
                                                        marginLeft: window.innerWidth < 768 ? 10 : 5,
                                                        marginRight: 10,
                                                        backgroundColor: "#EEE",
                                                        borderRadius: 5,
                                                        padding: 10,
                                                    }}
                                                >
                                                    <Select
                                                        name="id_unidade_geradora_2"
                                                        options={listaUCsGeradorasAtivas.filter((item) => item.id != 0 && item.id != props.ucFormularioValues.id_unidade_geradora)}
                                                        label={"Unidade Fonte Geradora 2"}
                                                        value={String(props.ucFormularioValues.id_unidade_geradora_2)}
                                                        cols="12 12 12 12"
                                                        placeholder="Selecione a UC"
                                                        readOnly={
                                                            readOnly ||
                                                            !props.ucFormularioValues.percentual_geracao_externa ||
                                                            (!props.ucFormularioValues.id_unidade_geradora && !props.ucFormularioValues.geradora_externa)
                                                        }
                                                        isClearable={true}
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                id_unidade_geradora_2: JSON.parse(data), //se é null é pq a geradora é de fora do gradios
                                                            });
                                                        }}
                                                    />
                                                    <LabelAndInputNumber
                                                        title={`Nesse local deve colocar o percentual de energia que recebe ${
                                                            props.ucFormularioValues.possui_contrato_aluguel ? "da usina alugada" : "da outra usina própria"
                                                        }`}
                                                        allowNegative={false}
                                                        name="percentual_geracao_externa_2"
                                                        label={
                                                            <div>
                                                                <div style={{ color: "#F44", display: "flex", fontWeight: "bold" }}>
                                                                    <AlertIcon animationClass={"alerta-triangulo-visualizado"} event={() => {}} />
                                                                    Cuidar esse item para colocar exatamento como está no Anexo G
                                                                </div>
                                                                <div className="mt-2">
                                                                    Percentual de Geração Recebido{" "}
                                                                    {props.ucFormularioValues.possui_contrato_aluguel ? "da Usina Alugada" : "da Outra Usina Própria"}
                                                                </div>
                                                            </div>
                                                        }
                                                        cols="12 12 12 12"
                                                        placeholder={`Informe o percentual de geração recebido ${
                                                            props.ucFormularioValues.possui_contrato_aluguel ? "da usina alugada" : "da outra usina própria"
                                                        }`}
                                                        readOnly={readOnly}
                                                        casas={2}
                                                        value={
                                                            parseFloat(props.ucFormularioValues.percentual_geracao_externa_2) >= 0
                                                                ? String(props.ucFormularioValues.percentual_geracao_externa_2).replace(".", ",")
                                                                : null
                                                        }
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                percentual_geracao_externa_2:
                                                                    parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </Grid>
                                        </Row>
                                    </>
                                )}

                                {state.classificacaoGeracao === "Unidade Geradora (Própria)" ? (
                                    <Row style={{ padding: 8 }}>
                                        <LabelAndInputNumber
                                            title="Colocar o percentual do injetado que fica da produção da própria unidade geradora"
                                            allowNegative={false}
                                            name="percentual_geracao"
                                            label={<div style={{ marginTop: 0 }}>Percentual da Geração Própria</div>}
                                            cols={"12 12 12 12"}
                                            placeholder="Informe o percentual de geração própria"
                                            readOnly={readOnly}
                                            casas={2}
                                            value={
                                                parseFloat(props.ucFormularioValues.percentual_geracao) >= 0
                                                    ? String(props.ucFormularioValues.percentual_geracao).replace(".", ",")
                                                    : null
                                            }
                                            onChange={(data) => {
                                                props.initUcForm({
                                                    ...props.ucFormularioValues,
                                                    percentual_geracao: parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                });
                                            }}
                                        />
                                    </Row>
                                ) : state.classificacaoGeracao === "Unidade Remota" || state.exibirTransformarRemotaEmGeradora ? (
                                    <>
                                        <Row>
                                            <Grid
                                                cols="12 12 6 6"
                                                title={
                                                    props.ucFormularioValues.id && state.exibirTransformarRemotaEmGeradora
                                                        ? `Essa unidade fonte deve ficar informada pelo motivo que foi transformada de Remota para Geradora a partir de ${props.ucFormularioValues.competencia_inicio_geracao}`
                                                        : ""
                                                }
                                            >
                                                <div
                                                    style={{
                                                        marginLeft: 10,
                                                        marginRight: window.innerWidth < 768 ? 10 : 5,
                                                        backgroundColor: "#EEE",
                                                        borderRadius: 5,
                                                        padding: 10,
                                                    }}
                                                >
                                                    <Select
                                                        name="id_unidade_geradora"
                                                        options={listaUCsGeradorasAtivas}
                                                        label={
                                                            "Unidade Fonte Geradora 1" + (props.ucFormularioValues.id && state.exibirTransformarRemotaEmGeradora ? " (Antiga)" : "")
                                                        }
                                                        value={String(props.ucFormularioValues.id_unidade_geradora)}
                                                        cols="12 12 12 12"
                                                        placeholder="Selecione a UC"
                                                        readOnly={readOnly || state.exibirTransformarRemotaEmGeradora}
                                                        isClearable={true}
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                id_unidade_geradora: JSON.parse(data), //se é null é pq a geradora é de fora do gradios
                                                                geradora_externa: data == 0,
                                                            });
                                                        }}
                                                    />
                                                    {!state.exibirTransformarRemotaEmGeradora && (
                                                        <LabelAndInputNumber
                                                            title="Colocar o percentual recebido da fonte geradora 1"
                                                            allowNegative={false}
                                                            name="percentual_geracao"
                                                            label={"Percentual Recebido da Geradora 1"}
                                                            cols={"12 12 12 12"}
                                                            placeholder="Informe o percentual recebido da geradora 1"
                                                            readOnly={readOnly || state.exibirTransformarRemotaEmGeradora}
                                                            casas={2}
                                                            value={
                                                                parseFloat(props.ucFormularioValues.percentual_geracao) >= 0
                                                                    ? String(props.ucFormularioValues.percentual_geracao).replace(".", ",")
                                                                    : null
                                                            }
                                                            onChange={(data) => {
                                                                props.initUcForm({
                                                                    ...props.ucFormularioValues,
                                                                    percentual_geracao: parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </Grid>
                                            <Grid
                                                cols="12 12 6 6"
                                                title={
                                                    props.ucFormularioValues.id && state.exibirTransformarRemotaEmGeradora
                                                        ? `Essa unidade fonte deve ficar informada pelo motivo que foi transformada de Remota para Geradora a partir de ${props.ucFormularioValues.competencia_inicio_geracao}`
                                                        : ""
                                                }
                                            >
                                                <div
                                                    style={{
                                                        marginLeft: window.innerWidth < 768 ? 10 : 5,
                                                        marginRight: 10,
                                                        backgroundColor: "#EEE",
                                                        borderRadius: 5,
                                                        padding: 10,
                                                    }}
                                                >
                                                    <Select
                                                        name="id_unidade_geradora_2"
                                                        options={listaUCsGeradorasAtivas.filter((item) => item.id != 0 && item.id != props.ucFormularioValues.id_unidade_geradora)}
                                                        label={
                                                            "Unidade Fonte Geradora 2" + (props.ucFormularioValues.id && state.exibirTransformarRemotaEmGeradora ? " (Antiga)" : "")
                                                        }
                                                        value={String(props.ucFormularioValues.id_unidade_geradora_2)}
                                                        cols="12 12 12 12"
                                                        placeholder="Selecione a UC"
                                                        readOnly={
                                                            readOnly ||
                                                            state.exibirTransformarRemotaEmGeradora ||
                                                            !props.ucFormularioValues.percentual_geracao ||
                                                            (!props.ucFormularioValues.id_unidade_geradora && !props.ucFormularioValues.geradora_externa)
                                                        }
                                                        isClearable={true}
                                                        onChange={(data) => {
                                                            props.initUcForm({
                                                                ...props.ucFormularioValues,
                                                                id_unidade_geradora_2: JSON.parse(data), //se é null é pq a geradora é de fora do gradios
                                                            });
                                                        }}
                                                    />
                                                    {!state.exibirTransformarRemotaEmGeradora && (
                                                        <LabelAndInputNumber
                                                            title="Colocar o percentual recebido da fonte geradora 2"
                                                            allowNegative={false}
                                                            name="percentual_geracao_2"
                                                            label={"Percentual Recebido da Geradora 2"}
                                                            cols={"12 12 12 12"}
                                                            placeholder="Informe o percentual recebido da geradora 2"
                                                            readOnly={
                                                                readOnly ||
                                                                state.exibirTransformarRemotaEmGeradora ||
                                                                !props.ucFormularioValues.percentual_geracao ||
                                                                (!props.ucFormularioValues.id_unidade_geradora && !props.ucFormularioValues.geradora_externa)
                                                            }
                                                            casas={2}
                                                            value={
                                                                parseFloat(props.ucFormularioValues.percentual_geracao_2) >= 0
                                                                    ? String(props.ucFormularioValues.percentual_geracao_2).replace(".", ",")
                                                                    : null
                                                            }
                                                            onChange={(data) => {
                                                                props.initUcForm({
                                                                    ...props.ucFormularioValues,
                                                                    percentual_geracao_2: parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                                });
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </Grid>
                                        </Row>
                                        {state.exibirTransformarRemotaEmGeradora && (
                                            <Row style={{ padding: 8 }}>
                                                <LabelAndInputNumber
                                                    title="Colocar o percentual do injetado que fica da produção da própria unidade geradora"
                                                    allowNegative={false}
                                                    name="percentual_geracao"
                                                    label={<div style={{ marginTop: 0 }}>Percentual da Geração Própria</div>}
                                                    cols={"12 12 12 12"}
                                                    placeholder="Informe o percentual de geração própria"
                                                    readOnly={readOnly}
                                                    casas={2}
                                                    value={
                                                        parseFloat(props.ucFormularioValues.percentual_geracao) >= 0
                                                            ? String(props.ucFormularioValues.percentual_geracao).replace(".", ",")
                                                            : null
                                                    }
                                                    onChange={(data) => {
                                                        props.initUcForm({
                                                            ...props.ucFormularioValues,
                                                            percentual_geracao: parseFloat(data.target.value) >= 0 ? String(data.target.value).replace(",", ".") : null,
                                                        });
                                                    }}
                                                />
                                            </Row>
                                        )}
                                    </>
                                ) : null}
                                {props.ucFormularioValues.remotas_alugadas.length > 0 && (
                                    <Row style={{ marginBottom: 30, marginInline: 10, border: "1px solid #EEE", padding: 20, backgroundColor: "#FAFAFA" }}>
                                        <Table responsive>
                                            <THead>
                                                <Tr>
                                                    <Th colSpan="3" alignCenter>
                                                        Unidades que são remotas ou alugam energia desta unidade
                                                    </Th>
                                                </Tr>
                                                <Tr>
                                                    <Th alignCenter>Tipo de Relação</Th>
                                                    <Th alignCenter>Nº UC</Th>
                                                    <Th alignCenter>Percentual que recebe</Th>
                                                </Tr>
                                            </THead>
                                            <TBody>
                                                {props.ucFormularioValues.remotas_alugadas.map((uc) => (
                                                    <Tr>
                                                        <Td alignCenter>{uc.tipo}</Td>
                                                        <Td alignCenter>{uc.numero}</Td>
                                                        <Td alignCenter>{adicionarPontosMilhar(uc.percentual_geracao_recebido) + "%"}</Td>
                                                    </Tr>
                                                ))}
                                            </TBody>
                                        </Table>
                                    </Row>
                                )}
                                <>
                                    <LabelAndCheckbox
                                        style={{ marginRight: 10 }}
                                        component={LabelAndCheckbox}
                                        label="Usuário de Implantação"
                                        cols="12 12 12 12"
                                        readOnly={readOnly || props.usuarioLogado.usuario_implantacao}
                                        value={!!props.ucFormularioValues.usuario_implantacao}
                                        onChange={() => {
                                            props.initUcForm({
                                                ...props.ucFormularioValues,
                                                usuario_implantacao: !props.ucFormularioValues.usuario_implantacao,
                                                id_usuario_implantacao: !props.ucFormularioValues.usuario_implantacao ? props.ucFormularioValues.id_usuario_implantacao : null,
                                            });
                                        }}
                                    />
                                    {props.ucFormularioValues.usuario_implantacao && (
                                        <Field
                                            component={Select}
                                            name="id_usuario_implantacao"
                                            options={props.listaUsuarioImplantacao}
                                            label="Nome do Usuário de Implantação"
                                            cols="12 12 12 12"
                                            placeholder="Selecione o usuário de implantação"
                                            readOnly={readOnly || props.usuarioLogado.usuario_implantacao}
                                        />
                                    )}
                                </>
                                {props.ucFormularioValues.id > 0 && (
                                    <LabelAndTextarea
                                        label="Mensagens das Rotinas de Importação"
                                        cols="12 12 12 12"
                                        value={props.ucFormularioValues.mensagens_importacao}
                                        readOnly={true}
                                        style={{
                                            width: "100%",
                                            height: 150,
                                            resize: "none",
                                            backgroundColor: (String(props.ucFormularioValues.mensagens_importacao).match(/OK/g) || []).length < 3 ? "#f74c4c" : "#52b7ae",
                                            color: "#ffffff",
                                        }}
                                    />
                                )}
                            </Grid>
                        )}
                        {state.abaAguaAtiva && (
                            <Grid cols="12 12 12 12" style={{ paddingBlock: 20, paddingInline: 5 }}>
                                <Row
                                    style={{
                                        padding: "10px 10px 0px 0px ",
                                    }}
                                >
                                    <Grid
                                        cols="12 12 12 12"
                                        style={{
                                            marginBlock: 15,
                                        }}
                                    >
                                        <Grid cols="12 12 12 12">
                                            <h6 style={{ paddingInline: 5, paddingBottom: 20 }}>Acesso Concessionária de Água</h6>
                                        </Grid>
                                        {!state.formUCAgua && (
                                            <Grid cols="12 12 4 4" style={{ paddingTop: 5, paddingBottom: 20 }}>
                                                <Button
                                                    text="Adicionar"
                                                    type={"primary"}
                                                    disabled={readOnly}
                                                    event={() => {
                                                        setState({
                                                            ...state,
                                                            formUCAgua: {
                                                                dados: {
                                                                    id_cliente: props.ucFormularioValues.id_cliente,
                                                                    id_unidade_consumidora: props.ucFormularioValues.id,
                                                                },
                                                                handleSubmit: (values) => {
                                                                    const submitPendente = () => props.salvarUCAgua(values);
                                                                    setState((prev) => ({
                                                                        ...prev,
                                                                        submitPendente,
                                                                        exibirModalConfirmarSubmit: true,
                                                                        tituloConfirmarSubmit: `Deseja realmente incluir a unidade consumidora água?`,
                                                                    }));
                                                                },
                                                                handleCancel: () => setState({ ...state, formUCAgua: null }),
                                                            },
                                                        });
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                        {state.formUCAgua && (
                                            <Grid cols="12 12 12 12">
                                                <UnidadeConsumidoraAguaForm
                                                    dados={state.formUCAgua.dados}
                                                    handleSubmit={state.formUCAgua.handleSubmit}
                                                    handleCancel={state.formUCAgua.handleCancel}
                                                />
                                            </Grid>
                                        )}
                                        <Table>
                                            <THead>
                                                <NewTr>
                                                    <Th maxWidth={70}>Código da Matrícula</Th>
                                                    <Th maxWidth={75}>Concessionária de Água</Th>
                                                    <Th>Login</Th>
                                                    <Th>Senha</Th>
                                                    <Th>Mensagem Download/Importação</Th>
                                                    <Th>Mensagem Importação Data Pagamento</Th>
                                                </NewTr>
                                            </THead>
                                            <TBody>
                                                {props.ucFormularioValues.unidades_consumidoras_agua.map((ucAgua) => {
                                                    const botoes = [
                                                        {
                                                            type: "warning",
                                                            icon: "fas fa-pencil-alt",
                                                            disabled: readOnly,
                                                            event: () => {
                                                                setState({
                                                                    ...state,
                                                                    formUCAgua: {
                                                                        dados: {
                                                                            ...ucAgua,
                                                                        },
                                                                        handleSubmit: (values) => {
                                                                            const submitPendente = () => props.salvarUCAgua(values);
                                                                            setState((prev) => ({
                                                                                ...prev,
                                                                                submitPendente,
                                                                                exibirModalConfirmarSubmit: true,
                                                                                tituloConfirmarSubmit: `Deseja salvar as alterações na unidade consumidora de água?`,
                                                                            }));
                                                                        },
                                                                        handleCancel: () => setState({ ...state, formUCAgua: null }),
                                                                    },
                                                                });
                                                            },
                                                        },
                                                        {
                                                            type: "danger",
                                                            icon: "fas fa-trash-alt",
                                                            disabled: readOnly,
                                                            event: () => {
                                                                const submitPendente = () => props.excluirUCAgua(ucAgua);
                                                                setState((prev) => ({
                                                                    ...prev,
                                                                    submitPendente,
                                                                    exibirModalConfirmarSubmit: true,
                                                                    tituloConfirmarSubmit: `Deseja realmente excluir a unidade consumidora de água?`,
                                                                }));
                                                            },
                                                        },
                                                    ];

                                                    const nomeConcessionaria =
                                                        (props.listaConcessionariaAgua.find((c) => ucAgua.id_concessionaria_agua == c.id) || {}).valor || " - ";
                                                    return (
                                                        <NewTr key={ucAgua.id} backgroundColorTd={"#FFF"} backgroundColorTr={"#FFF"} botoes={botoes}>
                                                            <Td>{ucAgua.numero}</Td>
                                                            <Td>{nomeConcessionaria}</Td>
                                                            <Td>{ucAgua.usuario}</Td>
                                                            <Td>{ucAgua.senha}</Td>
                                                            <Td maxWidth={90} verticalAlign="top">
                                                                <div
                                                                    style={{
                                                                        color: !(String(ucAgua.mensagem_ultima_importacao_fatura_agua).match(/OK/g) || []).length
                                                                            ? "#f74c4c"
                                                                            : "#52b7ae",
                                                                    }}
                                                                >
                                                                    {ucAgua.mensagem_ultima_importacao_fatura_agua}
                                                                </div>
                                                            </Td>
                                                            <Td maxWidth={90} verticalAlign="top">
                                                                <div
                                                                    style={{
                                                                        color: !(String(ucAgua.mensagem_ultima_importacao_data_pagamento_agua).match(/OK/g) || []).length
                                                                            ? "#f74c4c"
                                                                            : "#52b7ae",
                                                                    }}
                                                                >
                                                                    {ucAgua.mensagem_ultima_importacao_data_pagamento_agua}
                                                                </div>
                                                            </Td>
                                                        </NewTr>
                                                    );
                                                })}
                                            </TBody>
                                        </Table>
                                    </Grid>
                                </Row>
                            </Grid>
                        )}
                    </Grid>
                </ContentCardBody>
                {state.abaEnergiaAtiva && (
                    <ContentCardFooter>
                        <Row alignCenter={true}>
                            {props.excluir ? (
                                <>
                                    <Grid cols="12 12 4 4" style={{ paddingTop: 5 }}>
                                        <Button
                                            text="Inativar"
                                            type={"dark"}
                                            event={() => {
                                                const submitPendente = () =>
                                                    props.excluirUC({
                                                        id: props.ucFormularioValues.id,
                                                        id_cliente: props.ucFormularioValues.id_cliente, //precisa passar pra buscar a lista atualizada de UCs do cliente
                                                        exclusao_definitiva: false,
                                                    });
                                                setState((prev) => ({
                                                    ...prev,
                                                    submitPendente,
                                                    exibirModalConfirmarSubmit: true,
                                                    tituloConfirmarSubmit: `Deseja realmente inativar a unidade consumidora?`,
                                                }));
                                            }}
                                        />
                                    </Grid>
                                    <Grid cols="12 12 4 4" style={{ paddingTop: 5 }}>
                                        <Button
                                            text="Excluir Definitivamente"
                                            event={() => {
                                                const submitPendente = () =>
                                                    props.excluirUC({
                                                        id: props.ucFormularioValues.id,
                                                        id_cliente: props.ucFormularioValues.id_cliente, //precisa passar pra buscar a lista atualizada de UCs do cliente
                                                        exclusao_definitiva: true,
                                                    });
                                                setState((prev) => ({
                                                    ...prev,
                                                    submitPendente,
                                                    exibirModalConfirmarSubmit: true,
                                                    tituloConfirmarSubmit:
                                                        "Esta alteração não poderá ser revertida, deseja realmente excluir a unidade consumidora PERMANENTEMENTE do sistema?",
                                                }));
                                            }}
                                            type={"danger"}
                                        />
                                    </Grid>
                                </>
                            ) : (
                                <Grid cols="12 12 4 4" style={{ paddingTop: 5 }}>
                                    {props.reativar ? (
                                        <Button
                                            text="Reativar"
                                            type={"success"}
                                            event={() => {
                                                const submitPendente = () =>
                                                    props.reativarUC({
                                                        id: props.ucFormularioValues.id,
                                                        id_cliente: props.ucFormularioValues.id_cliente, //precisa passar pra buscar a lista atualizada de UCs do cliente
                                                    });
                                                setState((prev) => ({
                                                    ...prev,
                                                    submitPendente,
                                                    exibirModalConfirmarSubmit: true,
                                                    tituloConfirmarSubmit: "Deseja realmente reativar a unidade consumidora?",
                                                }));
                                            }}
                                        />
                                    ) : (
                                        <Button
                                            ref={botaoSubmitRef}
                                            text="Salvar"
                                            submit
                                            style={validarAlteracoesFormulario() ? { boxShadow: "0 0 8px #00ff7b" } : {}}
                                            type={"success"}
                                            disabled={readOnly}
                                        />
                                    )}
                                </Grid>
                            )}

                            <Grid cols="12 12 4 4" style={{ paddingTop: 5 }}>
                                <Button
                                    text="Voltar"
                                    type={"warning"}
                                    icon={"fa fa-chevron-left"}
                                    event={() => {
                                        if (validarAlteracoesFormulario()) {
                                            setState({ ...state, exibirModalAlteracaoUcVoltar: true });
                                        } else {
                                            props.initUcForm({ ...state.ucOriginal });
                                            props.getListaUCsCliente(props.ucFormularioValues.id_cliente);
                                        }
                                    }}
                                />
                            </Grid>
                        </Row>
                    </ContentCardFooter>
                )}
            </Form>
        </ContentCard>
    );
}

const UnidadeConsumidoraFormRedux = reduxForm({ form: "unidadeConsumidoraForm", destroyOnUnmount: false })(UnidadeConsumidoraForm);
const mapStateToProps = (state) => ({
    modoTelaUC: state.cliente.modoTelaUC,
    usuarioLogado: state.auth.usuarioLogado,
    listaUsuarioImplantacao: state.usuario.lista.filter((item) => item.usuario_implantacao).map((item) => ({ id: item.id, valor: item.nome })),
    ucFormularioValues: getFormValues("unidadeConsumidoraForm")(state),
    listaUcCliente: getFormValues("clienteForm")(state).itens,
    listaTributacao: state.tributacao.lista,
    listaEstado: state.tributacao.listaEstado,
    listaAtividade: state.tributacao.listaAtividade,
    listaGeracaoTipo: state.cliente.listaGeracaoTipo,
    listaTipoMedicao: state.cliente.listaTipoMedicao,
    listaTipoMercado: state.cliente.listaTipoMercado,
    listaConcessionaria: state.cliente.listaConcessionaria,
    listaGrupoFaturamento: state.cliente.listaGrupoFaturamento,
    listaTipoTransformador: state.cliente.listaTipoTransformador,
    listaConcessionariaAgua: state.cliente.listaConcessionariaAgua,
    listaSubgrupoFaturamento: state.cliente.listaSubgrupoFaturamento,
    listaModalidadeTarifaria: state.cliente.listaModalidadeTarifaria,
    listaPlataformaMercadoLivre: state.cliente.listaPlataformaMercadoLivre,
    listaModalidadeMercadoLivre: state.cliente.listaModalidadeMercadoLivre,
    listaTipoEnergiaMercadoLivre: state.cliente.listaTipoEnergiaMercadoLivre,
    tiposContratosDemandaAtivosUc: state.cliente.tiposContratosDemandaAtivosUc,
    listaGestorConcessionaria: state.gestorConcessionaria.listaGestorConcessionariaSelect,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTelaUC,
            initUcForm,
            excluirUC,
            reativarUC,
            salvarUCAgua,
            excluirUCAgua,
            alterarPropriedadeUC,
            getListaUCsCliente,
            buscarTiposContratoAtivo,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(UnidadeConsumidoraFormRedux);
